export default __webpack_public_path__ + "static/media/mantle001.4cda8b0e.jpeg";